﻿(function () {
    "use strict";

    angular
        .module("app")
        .component("elementsSidebar", {
            bindings: {
                api: '@?',
                data: '<?',
                component: '=?',
                element: '@',
                header: '@?',
                updateHash: '@?',
                externalUrl: '@?',
                dragTarget: '@?',
                dragTargetDynamic: '<?',
                onLoad: '&',
                onSync: "&",
                onBeforeSelect: '&',
                onSelect: '&',
                onAdd: '&',
                onDragStart: '&',
                onDragStop: '&',
                hideAddButton: '@?',
                searchKey: '@?',
                orderBy: '@?',
                orderAscending: '@?',
                height: '@?',
                scrollDownPagination: '@?',
                moreButtonPagination: '@?',
                onComponentLoaded: '&',
                additionalParameters: '@?',
                disableSearchFilter: '@?',
                orderableElements: '=',
                reorderElements: '&'
            },
            templateUrl: ['version', function (version) {
                return `/js/components/elementsSidebar/elements-sidebar.html?v=${version}`
            }],
            transclude: {
                'titleTemplate': '?titleTemplate',
                'secondaryTemplate': '?secondaryTemplate',
                'addTemplate': '?addTemplate',
                'functionTemplateA': '?functionTemplateA',
                'elementTemplate': 'elementTemplate',
                'footerTemplate': '?footerTemplate'
            },
            controller: ElementsSidebarController,
            controllerAs: "vm"
        });

    ElementsSidebarController.$inject = ["$scope", "$rootScope", "$location", "request", "$timeout", "$q", "$element", "$attrs", "$transclude", 'auth', '$filter'];

    function ElementsSidebarController($scope, $rootScope, $location, request, $timeout, $q, $element, $attrs, $transclude, auth, $filter) {
        var vm = this,
            previousElement,
            page = 1,
            limit = 25,
            additionalParameters = {};

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;
        vm.$onDestroy = onDestroy;

        vm.localSidebarSearches = {};

        vm.elements;
        vm.isLoading = false;
        vm.isAdding = false;
        vm.maxHeight = 0;

        vm.sync = sync;
        vm.addItem = addItem;
        vm.selectElement = selectElement;
        vm.selectElementByCallback = selectElementByCallback;
        vm.calculateMaxHeight = calculateMaxHeight;

        vm.hasSlot = hasSlot;
        vm.reverseSort = reverseSort;

        vm.loadData = loadData;
        vm.isTouchDevice = $rootScope.isTouchDevice()

        vm.moreButtonPageSize = 100
        vm.moreButtonElementsToDisplay = 100
        vm.shouldShowMoreButton = false

        vm.dragNDropRetriesStarted = false
        vm.dragNDropRetriesLeft = 60
        vm.dragNDropRetryDelay = 1000
        vm.dragNDropRetryBackOff = 250

        vm.showDragHandle = false

        vm.notificationDuration = 0
        vm.notificationType = ''
        vm.notificationMessage = ''
        vm.notificationOnClose = () => {
          vm.notificationMessage = ''
        }

        function showNotification(duration, type, message) {
            vm.notificationDuration = duration
            vm.notificationType = type
            vm.notificationMessage = message
            vm.notificationNonce = Math.random()
        }

        $scope.$watch("vm.dragTargetDynamic", function (value) {
            // dragTarget changed. Reconfigure elements connection to target.
            configureDragNDrop();
        });

        $scope.$watch("vm.additionalParameters", function (newVal, oldVal) {
            if (newVal) {
                try {
                    additionalParameters = JSON.parse(vm.additionalParameters);
                } catch (e) {
                    console.log("Cannot parse additionalParameters: ", e.message);
                }
            }
            if (useScrollDownPagination()) {
                if ((additionalParameters.canPerformCall !== undefined && additionalParameters.canPerformCall === 'true')
                    || additionalParameters.canPerformCall === undefined) {
                    loadDataOverwrite();
                }
            }
        });

        $scope.$watch("vm.sidebarSearch", function (newVal, oldVal) {
            if (newVal !== oldVal && vm.searchKey !== undefined) {
                if (newVal == '') {
                    delete vm.localSidebarSearches[vm.searchKey];
                } else {
                    vm.localSidebarSearches[vm.searchKey] = newVal;
                }
                localStorage.setItem("localSidebarSearches", angular.toJson(vm.localSidebarSearches))

                if (useScrollDownPagination()) {
                    loadDataOverwrite(false);
                }
            }

            if (useMoreButtonPagination()) {
                updateMoreButtonFilter(vm.data)
                loadElements()
            }
        });

        $scope.$watch("vm.orderableElements", function (value) {
            if (vm.orderableElements !== undefined)
                enableOrderableElements();
        });

        function onInit() {
            vm.component = vm;
            vm.height = vm.height || '100vh';

            window.addEventListener('resize', calculateMaxHeight);
            getLocalSidebarSearch();

            // set the sidebarSearch element from url, to have the sidebar pagination select work
            // id.match check, prevents searching by anything other than urls with ids. e.g. #actual-items
            // $location.hash() checks for the # hash paramter in the url and not the angular #! hash one
            var id = $location.hash();
            if (id) {
                if (id.match(/^\d+/)) {
                    vm.sidebarSearch = angular.copy(id.substr(id.indexOf('-') + 1).replace(/\-/g, ' '));
                }
            }

            if (vm.api) {
                if (useScrollDownPagination()) {
                    $timeout(function () {
                        $scope.$apply();
                        vm.onComponentLoaded();
                        $("#infinite-list").scroll(function (event) {
                            if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight - 10) {
                                if (!$(".loadingMore").length && !$(".noMoreData").length) {
                                    $("#infinite-list").append($("<li class='loadingMore'>Loading...</li>").fadeIn('slow'));
                                    page++;
                                    loadData();
                                }
                            }
                        });
                    });
                }
                else {
                    loadApiElements();
                }
            }

            if (vm.data) {
                if (useMoreButtonPagination()) {
                    updateMoreButtonFilter(vm.data)
                } else {
                    vm.elements = vm.data;
                }
            }

            angular.element(document).ready(function () {
                setTimeout(function () { calculateMaxHeight(); }, 100)
            });

            updateShowDragHandle()
        }

        function updateShowDragHandle() {
            vm.showDragHandle = vm.orderableElements || (vm.isTouchDevice && (vm.dragTargetDynamic !== undefined || $attrs.dragTarget !== undefined))
        }

        function showMore() {
            vm.moreButtonElementsToDisplay += vm.moreButtonPageSize
            updateMoreButtonFilter(vm.data)
            loadElements()
        }

        vm.showMore = showMore

        function updateMoreButtonFilter(data) {
            var fullElementList = data.filter(x => x.visible !== false)
            if (!vm.disableSearchFilter && vm.sidebarSearch && vm.sidebarSearch.length > 0) {
                fullElementList = $filter('filter')(fullElementList, vm.sidebarSearch)
            }
            vm.elements = fullElementList.filter((x, i) => i < vm.moreButtonElementsToDisplay)
            vm.shouldShowMoreButton = fullElementList.length > vm.moreButtonElementsToDisplay
        }

        function getLocalSidebarSearch() {
            if (localStorage.getItem("localSidebarSearches") !== null && vm.searchKey !== undefined) {
                vm.localSidebarSearches = angular.fromJson(localStorage.getItem("localSidebarSearches"));
                vm.sidebarSearch = vm.localSidebarSearches[vm.searchKey];
            }
        }

        function onDestroy() {
            window.removeEventListener('resize', calculateMaxHeight);
        }

        function calculateMaxHeight() {
            vm.maxHeight = $element[0].firstChild.querySelector('#infinite-list').offsetTop;
        }

        function onChanges(obj) {
            if (obj.data && obj.data.currentValue) {
                if (useMoreButtonPagination()) {
                    updateMoreButtonFilter(obj.data.currentValue)
                } else {
                    vm.elements = obj.data.currentValue
                }
                
                loadElements();
                angular.forEach(vm.elements, function (value) {
                    if (value.__selected) {
                        previousElement = value;
                    }
                });
            }
            calculateMaxHeight()
        }

        function loadApiElements() {
            var deferred = $q.defer();

            vm.isLoading = true;
            request.get($rootScope.apiEndpoint + vm.api).then(function (response) {
                vm.elements = response.data;
                loadElements();

                $timeout(function () {
                    $scope.$apply();
                    deferred.resolve();

                });

            }, function () {
                showNotification(5, 'Error', 'There was an error loading the data')
                deferred.reject();

            }).then(function () {
                vm.isLoading = false;
            });

            return deferred.promise;
        }

        function loadElements() {
            var id = $location.hash(),
                matched = false;

            if (vm.header) {
                var lastHeader,
                    headerInserts = [];

                angular.forEach(vm.elements, function (value, index) {
                    if (value[vm.header] !== lastHeader) {
                        headerInserts.push({ index: index, item: { text: value[vm.header], __isHeader: true } });
                        lastHeader = value[vm.header];
                    }
                });

                angular.forEach(headerInserts, function (value, index) {
                    vm.elements.splice(value.index + index, 0, value.item);
                });
            }

            if (id) {
                var idMatch = id.match(/^\d+/);

                if (idMatch) {
                    //numeric match
                    id = parseInt(idMatch[0]);
                    angular.forEach(vm.elements, function (value) {
                        if (!matched && value.id === id || value.url && value.url.toLowerCase() === id) {
                            selectElement(value);
                            matched = true;
                        }
                    });
                } else {
                    //full-text match
                    id = id.toLowerCase();

                    angular.forEach(vm.elements, function (value) {
                        if (!matched && value.id.toString().toLowerCase() === id || value.url && value.url.toLowerCase() === id) {
                            selectElement(value);
                            matched = true;
                        }
                    });
                }
            }

            if (vm.onLoad && vm.elements) {
                vm.onLoad({ 'elements': vm.elements });
            }

            configureDragNDrop();
        }

        /*
         * Function called when loading elements and when vm.dropTarget is changed 
         * Configures the drag & drop actions and elements connection to the target
         */
        function configureDragNDrop(isRetry = false) {
            var connectTo = vm.dragTargetDynamic ? vm.dragTargetDynamic : $attrs.dragTarget;
            if (connectTo !== undefined) {
                $timeout(function () {
                    var elements = $("li", $element)
                    if (elements.length < 2 && vm.elements && (!vm.dragNDropRetriesStarted || isRetry)) {
                        if (vm.dragNDropRetriesLeft > 1) {
                            $timeout(() => configureDragNDrop(true), vm.dragNDropRetryDelay)
                        }
                        vm.dragNDropRetriesLeft--
                        vm.dragNDropRetryDelay += vm.dragNDropRetryBackOff
                    }
                    elements.draggable({
                        appendTo: "#main",
                        connectToSortable: connectTo,
                        helper: "clone",
                        handle: vm.isTouchDevice ? $('.touch-drag-handle', $element) : undefined,
                        zIndex: 999,
                        start: function (event, ui) {
                            const targetScope = angular.element(event.target).scope();
                            if (targetScope && targetScope.element) {
                                ui.helper.data("element", targetScope.element);
                                vm.onDragStart({ "element": targetScope.element });
                            }
                        },
                        stop: function (event) {
                            const targetScope = angular.element(event.target).scope();
                            if (targetScope && targetScope.element) {
                                vm.onDragStop({ "element": targetScope.element });
                            }
                        }
                    });
                }, 250);
            }
            updateShowDragHandle()
        }

        function sync(resetSearch = true) {
            var deferred = $q.defer();

            vm.onSync();
            if (!vm.api) return;

            if (useScrollDownPagination()) {
                vm.isLoading = true;
                vm.sidebarSearch = '';
                page = 1;
                loadData(true);
            } else {
                if (resetSearch) vm.sidebarSearch = '';

                loadApiElements().then(function () {
                    return deferred.resolve();
                }, function () {
                    return deferred.reject();
                });
            }
            return deferred.promise;
        }

        function addItem() {
            if (vm.onBeforeSelect) {
                var canContinue;

                canContinue = vm.onBeforeSelect({ 'element': null });
                if (canContinue === false) return;
            }

            if (previousElement) previousElement.__selected = false;
            vm.isAdding = true;
            vm.onAdd();
        }

        function selectElement(element, select = true) {
            if (!element || element.__isHeader || element.disabled) return;

            if (vm.onBeforeSelect) {
                var canContinue;

                canContinue = vm.onBeforeSelect({ 'element': element });
                if (canContinue === false) return;
            }

            if (previousElement) previousElement.__selected = false;
            vm.isAdding = false;
            element.__selected = true;
            if(select){
                vm.onSelect({ 'element': element })
            }
            previousElement = element;

            if (element.isExternalUrl) {
                window.open(element.url, '_self');
                return
            }

            if (vm.updateHash !== "false") {
                $location.hash(element.url);
            }
        }

        function selectElementByCallback(func) {
            // func(value, key) returns true to select the current element
            var selected = null;

            angular.forEach(vm.elements, function (value, key) {
                if (!selected && func(value, key)) {
                    selected = value;
                }
            });

            if (selected) {
                selectElement(selected);
            }
        }

        function hasSlot(name) {
            return $transclude.isSlotFilled(name);
        }

        function reverseSort() {
            // orderBy filter orders descending if parameter is true
            if (vm.orderAscending == undefined || vm.orderAscending == 'true') {
                return false; // orders array ascending
            } else {
                return true; // orders array descending
            }
        }

        function useScrollDownPagination() {
            return vm.scrollDownPagination && vm.scrollDownPagination.localeCompare("true") == 0;
        }

        function useMoreButtonPagination() {
            return vm.moreButtonPagination && vm.moreButtonPagination.localeCompare("true") == 0;
        }

        function loadDataOverwrite(loadingIndicator = true) {
            if ($(".noMoreData").length) {
                $(".noMoreData").fadeOut('fast', function () {
                    $(this).remove();
                });
            }

            if (!$(".loadingMore").length) {
                $("#infinite-list").append($("<li class='loadingMore'>Loading...</li>").fadeIn('slow'));
            }

            page = 1;
            if (loadingIndicator) {
                vm.isLoading = true;
            }
            loadData(true);
        }

        function loadData(overwriteResult = false) {
            var deferred = $q.defer();
            var requestData = {
                'page': page,
                'limit': vm.api === '/customers' ? 1000 : limit,
                'search': vm.sidebarSearch,
            };
            if (additionalParameters) {
                for (var prop in additionalParameters) {
                    requestData[prop] = additionalParameters[prop];
                }
            }
            $.ajax({
                'url': $rootScope.apiEndpoint + vm.api,
                'type': 'GET',
                'data': requestData,
                'headers': auth.headers(),
                'success': function (data) {
                    $(".loadingMore").fadeOut('fast', function () {
                        $(this).remove();
                    });

                    if (!data.items.length && !$(".noMoreData").length) {
                        var displayMessage = "";
                        if (vm.searchKey) displayMessage = ((!overwriteResult) ? ('End of results') : ('No matches. <br/> Try a different search'));

                        $("#infinite-list").append($("<li class='noMoreData'>" + displayMessage + "</li>").fadeIn('slow'));
                    }

                    if (overwriteResult) {
                        vm.elements = data.items;
                        $("#infinite-list").scrollTop(0);
                    } else {
                        Array.prototype.push.apply(vm.elements, data.items);
                    }

                    loadElements();

                    if (vm.isLoading) {
                        vm.isLoading = false;
                    }

                    $timeout(function () {
                        $scope.$apply();
                        deferred.resolve();
                        configureDragNDrop();
                    });
                },
                'error': function () {
                    showNotification(5, 'Error', 'There was an error loading the data')
                    deferred.reject();
                }
            });
        }

        function enableOrderableElements() {
            $("ul").sortable({
                items: 'li.drag-item',
                axis: "y",
                handle: ".grab-handle-right",
                placeholder: {
                    element: function (currentItem) {
                        return $('<li class="sortable-placeholder"></li>')[0];
                    },
                    update: function (container, p) {
                        return;
                    }
                },
                tolerance: "pointer",
                start: function (e, ui) {
                    // creates a temporary attribute on the element with the old index
                    $(this).attr('data-previndex', ui.item.index());
                },
                stop: function (e, ui) {
                    //gets the new and old index then removes the temporary attribute
                    var newIndex = ui.item.index();
                    var oldIndex = $(this).attr('data-previndex');
                    $(this).removeAttr('data-previndex');

                    // calculate and return the move parameter to the parent
                    // so that, this component is not concerned with the parent's array length or ordering
                    var move = newIndex - oldIndex;
                    vm.reorderElements({ 'newPosition': { id: ui.item[0].id, move: move } });
                }
            });
            updateShowDragHandle()
        }
    }
})();
